export class Testata {
  codice: number;
  descrizione: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Testata.ts